import React from 'react';
import { useRole, UserRole } from '../contexts/RoleContext';

interface RoleBasedContentProps {
  requiredRole: UserRole | UserRole[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const RoleBasedContent: React.FC<RoleBasedContentProps> = ({
  requiredRole,
  children,
  fallback = null,
}) => {
  const { hasPermission, isLoading } = useRole();

  // Don't render role-gated content while role is still loading
  if (isLoading) return <>{fallback}</>;

  // Check if user has required permission
  const isAuthorized = hasPermission(requiredRole);

  // Render children if authorized, otherwise render fallback
  return <>{isAuthorized ? children : fallback}</>;
};
